module.exports = __webpack_public_path__ + "static/media/close-icon-active.63bdfb8f.svg";